// Duration presets offered by the composer, in minutes.
export const DURATION_OPTIONS = [2, 5, 8, 10, 15, 30];

export const DEFAULT_DURATION = 5;
